const style = `
<style>
:host {
width: 100%;
}
.cta-1 {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    background: transparent;
    background: #000;
    border: 1px solid transparent;
    border-radius: 11px;
    color: #c3c7c7;
    font-family: GT-America-Standard-Regular, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif;
    font-weight: 400;
    height: 40px;
    line-height: 26px;
    line-height: 38px;
    outline: 1px solid transparent;
    padding: 4px 24px;
    text-align: center;
    text-transform: uppercase;
    transition: background .45s, color .45s, border .45s;
    -moz-transition: background .45s, color .45s, border .45s;
    -webkit-transition: background .45s, color .45s, border .45s;
    -ms-transition: background .45s, color .45s, border .45s;
    -o-transition: background .45s, color .45s, border .45s;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .cta-1:hover {
    background-color: #d2eae5;
    border-color: #d2eae5;
    color: #000;
  }

  .cta-1:disabled {
  background-color: grey;
  }

  .dash {
  border-bottom: 1px solid;
    display: inline-block;
    height: 1px;
    margin: 4px 6px;
    width: 27px;
  }
</style>
`;

export { style };
